import { Box } from "@mui/joy";
import DarkTypography from "../../common/DarkTypography";

export default function TrainingEmptyItem() {
  return (
    <Box component="div" sx={{ display: "flex", justifyContent: "center", py: 2 }}>
      <DarkTypography level="h4" colorVariant="muted">
        Aucune formation en cours
      </DarkTypography>
    </Box>
  );
}
